import React from "react";
import "./about.css"
import { FaArrowRight } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { Link } from "react-router-dom";

function About() {
  return (
    <div className="about">
      <div className="about-header">
        <h2 className="about-header-1">
          บริษัท <span style={{color : '#16409A'}}>Power Bunch </span>
          เริ่มก่อตั้งเมื่อปี พ.ศ. 2543 <br />
          เราให้ความสำคัญกับ
          ความซื่อสัตย์และความจริงใจในการค้าขาย พร้อมให้บริการ
          ลูกค้าด้วยมาตรฐานที่ชัดเจน
        </h2>
        <h2 className="about-header-2">
          ปี พ.ศ. 2564 เราได้ทำการเปิด
          ตลาดผลิตและนำเข้าเครื่องครัว
          แบบครงวงจร ภายใต้ชื่อ <span style={{color : '#16409A'}}>Factory Outlet Shop</span> 
        </h2>
        <a href="https://shopee.co.th/nichdaso?entryPoint=ShopBySearch&searchKeyword=factoryoutletshop" target="_blank" rel="noopener noreferrer"><p>ดูสินค้าของเรา <FaArrowRight className="right-icon" /></p></a>
      </div>
      
    
      <img src={require("../images/company-banner-small.jpg")} alt="" className="about-company-img"/>
    
      <div className="about-why-us">
        <div className="about-why-us-overall-container">
            <h1>ทำไมต้องเลือกเรา ?</h1>
        </div>
        
        <div className="about-flex-whyUs-container">
          
          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>จบครบในที่เดียว</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                ครบทุกเรื่อง ตั้งแต่ให้คำปรึกษา <br />
                ผลิต ติดตั้ง ไปจนถึงจัดหาอุปกรณ์
              </p>
            </div>
          </div>

          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>ให้คำปรึกษาโดยผู้เชี่ยวชาญ</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                มีผู้เชี่ยวชาญโดยเฉพาะ <br />
                ทางด้านระบบห้องครัว สแตนเลสและโลหะ
              </p>
            </div>
          </div>

          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>ประสบการณ์กว่า 30 ปี</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                โรงงานเราเปิดมายาวนาน ทำให้มีความเชี่ยวชาญ <br />
                ในด้านระบบห้องครัว สแตนเลสและโลหะ
              </p>
            </div>
          </div>

        </div>

        <div className="about-flex-whyUs-container">
          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>มาตรฐานดีเยี่ยม ราคาย่อมเยา</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                ใช้สแตนเลส และโลหะคุณภาพดีใช้งานได้จริง <br />
                ในราคาที่ย่อมเยาและคุ้มค่า
              </p>
            </div>
          </div>

          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>รับประกันและบริการทั่วไทย</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                รับประกันทุกชิ้นงานจากโรงงาน <br />
                บริการติดตั้งและจัดส่งทั่วประเทศไทย
              </p>
            </div>
          </div>
        </div>
        
      </div>

      <div className="service3-link-container">
        <a href="https://shopee.co.th/nichdaso?entryPoint=ShopBySearch&searchKeyword=factoryoutletshop" target="_blank" rel="noopener noreferrer"><p>ดูสินค้าของเรา <FaArrowRight className="right-icon" /></p></a>
        <Link to="/contact"><p>ขอคำแนะนำจากผู้เชี่ยวชาญ <FaArrowRight className="right-icon" /></p></Link>
      </div>

    </div>
  );
}

export default About;
